import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './providers/theme-provider';
import { AuthProvider } from './providers/auth-provider';
import { RealtimeProvider } from './providers/realtime-provider';
import { Toaster } from './components/ui/sonner';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="dark" enableSystem>
      <AuthProvider>
        <RealtimeProvider>
          <App />
          <Toaster position="bottom-right" />
        </RealtimeProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);